// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__1yOkH","colMaxWidth":"Table_colMaxWidth__3UXxI"};